export default __webpack_public_path__ + "static/media/apply.576172f0.png";